import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createElement as _createElement } from "react";
import { useState } from "react";
import { ExpandedReviewItem } from "./ExpandedReviewItem";
import { LargeReviewItem } from "./LargeReviewItem";
import { SummaryReviewItem } from "./SummaryReviewItem";
import { ReviewListContainer } from "./Reviews.styles";
var ReviewList = function(props) {
    var largeReviews = props.largeReviews, locationName = props.locationName, items = props.items;
    var ref = useState(), selectedItem = ref[0], setSelectedItem = ref[1];
    var Item = largeReviews ? LargeReviewItem : SummaryReviewItem;
    return /*#__PURE__*/ _jsx(ReviewListContainer, {
        children: selectedItem ? /*#__PURE__*/ _jsx(ExpandedReviewItem, _object_spread_props(_object_spread({}, selectedItem), {
            locationName: locationName,
            onClose: function() {
                return setSelectedItem(null);
            }
        })) : /*#__PURE__*/ _jsx("ul", {
            children: items.map(function(item) {
                return /*#__PURE__*/ _createElement(Item, _object_spread_props(_object_spread({}, item), {
                    locationName: locationName,
                    element: "li",
                    key: item.reviewerName,
                    onClick: function() {
                        return setSelectedItem(item);
                    }
                }));
            })
        })
    });
};
export { ReviewList };
